import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const BoardUnderlineIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M7.98198 1V11.902C7.98198 14.893 9.08098 16.441 12.006 16.441C14.931 16.441 16.028 14.893 16.028 11.902V1H19.006V11.446C19.006 16.618 17.129 19 12.006 19C6.88298 19 5.00598 16.617 5.00598 11.446V1H7.98198Z"
        fill={color}
      />
      <path d="M2 23V21H22V23H2Z" fill={color} />
    </BaseIcon>
  ),
);

BoardUnderlineIcon.displayName = 'BoardUnderlineIcon';
